import { parseTemplate } from 'url-template';
import ApiClient from '~/ApiClient';

export interface Result {
	items: string[];
}

export const findSavingGroups = async (client: ApiClient, userId: string, groupId: string): Promise<Result> => {
	const url = parseTemplate('users/{userId}/product-groups/{groupId}/cz-reimbursement-possible-savings-groups');
	const response = await client.fetch(url.expand({ userId, groupId }));
	return response.json();
};
